var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 3.6C3.33301 3.17565 3.50158 2.76869 3.80164 2.46863C4.1017 2.16857 4.50866 2 4.93301 2H8.60181C9.02612 2.00009 9.43302 2.16872 9.73301 2.4688L12.4642 5.2C12.7643 5.49999 12.9329 5.90689 12.933 6.3312V13.2C12.933 13.6243 12.7644 14.0313 12.4644 14.3314C12.1643 14.6314 11.7574 14.8 11.333 14.8H4.93301C4.50866 14.8 4.1017 14.6314 3.80164 14.3314C3.50158 14.0313 3.33301 13.6243 3.33301 13.2V3.6ZM4.93301 8.4C4.93301 8.18783 5.01729 7.98434 5.16732 7.83431C5.31735 7.68429 5.52083 7.6 5.73301 7.6H10.533C10.7452 7.6 10.9487 7.68429 11.0987 7.83431C11.2487 7.98434 11.333 8.18783 11.333 8.4C11.333 8.61217 11.2487 8.81566 11.0987 8.96569C10.9487 9.11571 10.7452 9.2 10.533 9.2H5.73301C5.52083 9.2 5.31735 9.11571 5.16732 8.96569C5.01729 8.81566 4.93301 8.61217 4.93301 8.4ZM5.73301 10.8C5.52083 10.8 5.31735 10.8843 5.16732 11.0343C5.01729 11.1843 4.93301 11.3878 4.93301 11.6C4.93301 11.8122 5.01729 12.0157 5.16732 12.1657C5.31735 12.3157 5.52083 12.4 5.73301 12.4H10.533C10.7452 12.4 10.9487 12.3157 11.0987 12.1657C11.2487 12.0157 11.333 11.8122 11.333 11.6C11.333 11.3878 11.2487 11.1843 11.0987 11.0343C10.9487 10.8843 10.7452 10.8 10.533 10.8H5.73301Z",
    fill: "#FFD233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8afce1a2fd5c5b33ed094980bc7c5fbb.svg";
export { ForwardRef as ReactComponent };